import { useCallback, useMemo } from 'react';

import { trackAnalyticsEvent } from '~/common/analytics/analyticsClient';
import { buildSegmentIdentity } from '~/common/analytics/segmentIdentity';
import { useClientId } from '~/hooks/useClientId';
import { useCurrentUser } from '~/hooks/useCurrentUser';

export function useAnalytics() {
  const user = useCurrentUser();
  const clientId = useClientId();
  const userId = user?.id;
  const clientName = user?.client_name;

  const identity = useMemo(
    () => buildSegmentIdentity(userId, clientId, clientName),
    [userId, clientId, clientName],
  );

  return useCallback(
    (event: string, properties?: Record<string, unknown>) => {
      trackAnalyticsEvent(event, {
        userId,
        clientId,
        ...properties,
        ...identity,
      });
    },
    [userId, clientId, identity],
  );
}
